import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  HostBinding,
} from '@angular/core';
import { styleVariables } from '../styles/variables';

/*
  NOTE: I more or less copied this component's rendering
  from a vanilla JS CodePen, there is room for improvement
  to make it a more Angular style component.
*/
@Component({
  selector: 'pg-spinner, grit-spinner',
  templateUrl: './pg-spinner.component.html',
  styleUrls: ['./pg-spinner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'pgSpinner, gritSpinner',
})
export class PgSpinnerComponent implements OnInit {
  @HostBinding('class.pg-spinner')
  _classPgSpinner = true;

  @HostBinding('class.white')
  get _classWhite() {
    return this.color === 'white';
  }

  @Input('color')
  color: string = styleVariables.colorPrimary;

  @HostBinding('style.width.px')
  get _width() {
    return this.size;
  }

  @HostBinding('style.height.px')
  get _height() {
    return this.size;
  }

  @Input()
  size = 24;

  @Input()
  strokeWidth = 2;

  constructor() {}

  ngOnInit() {}
}
